(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();

/* Armonico PDP swatches: colours of one product are photographed in the same pose, so their crops should sit
   in the same spot. If the auto-crop landed somewhere else for one colour, snap it to the group's median.
   The swatch row stays hidden until every swatch is painted and aligned, so nothing flashes a wrong crop. */
(function armonicoSwatchAlign() {
  var groups = document.querySelectorAll('.pdp1-swatches');
  if (!groups.length) return;

  var st = document.createElement('style');
  st.textContent = '.pdp1-swatches:not(.sw-align-done){opacity:0!important}.pdp1-swatches.sw-align-done{opacity:1;transition:opacity .15s ease}';
  document.head.appendChild(st);

  function parse(el) {
    if (!el.style.backgroundImage || el.style.backgroundImage === 'none') return null;
    var p = (el.style.backgroundPosition || '').split(/\s+/).map(parseFloat);
    if (p.length < 2 || isNaN(p[0]) || isNaN(p[1])) return null;
    return p;
  }
  function median(a) {
    var s = a.slice().sort(function (x, y) { return x - y; });
    var m = s.length >> 1;
    return s.length % 2 ? s[m] : (s[m - 1] + s[m]) / 2;
  }

  groups.forEach(function (group) {
    var done = false, tries = 0;
    function settled() {
      var els = group.querySelectorAll('.pdp1-swatch');
      for (var i = 0; i < els.length; i++) {
        if (!els[i].classList.contains('is-ready')) return false;
      }
      return els.length > 0;
    }
    function fix() {
      var els = Array.prototype.slice.call(group.querySelectorAll('.pdp1-swatch'));
      var pts = els.map(parse);
      var good = pts.filter(Boolean);
      if (good.length < 3) return;
      var mx = median(good.map(function (p) { return p[0]; }));
      var my = median(good.map(function (p) { return p[1]; }));
      els.forEach(function (el, i) {
        var p = pts[i];
        if (!p) return;
        if (Math.abs(p[0] - mx) > 8 || Math.abs(p[1] - my) > 8) {
          el.style.backgroundPosition = mx.toFixed(1) + '% ' + my.toFixed(1) + '%';
        }
      });
    }
    function finish() {
      if (done) return;
      done = true;
      fix();
      group.classList.add('sw-align-done');
      mo.disconnect();
      clearInterval(timer);
    }
    var mo = new MutationObserver(function () { if (settled()) finish(); });
    mo.observe(group, { subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    var timer = setInterval(function () {
      tries++;
      if (settled() || tries > 15) finish();
    }, 200);
    if (settled()) finish();
  });
})();
